export default __webpack_public_path__ + "static/media/library.f04a8992.svg";